export const defaultLanguage = 'en';

export const browserLocale = window.navigator.userLanguage
|| window.navigator.language
|| defaultLanguage;

export const i18nLocale = browserLocale.slice(0, 2);

export const getAntdLocale = () => {
  const antLocale = browserLocale.length === 5
    ? browserLocale.replace(/-/g, '_')
    : `${browserLocale}_${browserLocale.toUpperCase()}`;

  return import(`ant-design-vue/lib/locale-provider/${antLocale}`)
    .catch(() => import('ant-design-vue/lib/locale-provider/default.js'))
    .then(mod => mod.default);
};
